import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { Autocomplete } from 'ui/components/Autocomplete/Autocomplete';
import { LabelElement, DynamicDataField } from '../../../types';

interface DynamicAutocompleteProps {
  selectedElement: LabelElement;
  updateElementProperty: (field: keyof LabelElement, value: any) => void;
  availableFields: DynamicDataField[];
}

const DynamicAutocomplete: React.FC<DynamicAutocompleteProps> = ({
  selectedElement,
  updateElementProperty,
  availableFields,
}) => {
  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Dynamic Data
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Autocomplete
          label="Data Field"
          clearOnEscape
          clearIcon={true}
          value={selectedElement.dynamicField || ''}
          onChange={(event, newValue) => {
            updateElementProperty('dynamicField', newValue?.value || '');
          }}
          options={availableFields}
          getOptionLabel={(option) => {
            if (typeof option === 'string') {
              return (
                availableFields.find((item) => item.value === option)?.label ||
                option
              );
            }
            return option.label;
          }}
          renderOption={(props, option) => <li {...props}>{option.label}</li>}
          groupBy={(option) => option.group || ''}
        />
      </Box>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default DynamicAutocomplete;
